import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import entitiesReducer from './entities';
import uireducers from './uireducers';
// import App from './App'; // Assuming you have an App component

// Store configuration
export const store = configureStore({
  reducer: {
    entities: entitiesReducer,
    uielements: uireducers,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


